export const HOMEPAGE_GUIDE_PATH = '/blog/remote-team-halloween-games';
export const HOMEPAGE_GUIDE_PROMOTION = 'h0391_home_halloween';
// Gone after Halloween in Pacific time: midnight starting Nov 1, 2026 is still PDT (UTC-7).
export const HOMEPAGE_GUIDE_EXPIRY = Date.parse('2026-11-01T07:00:00Z');
export const HOMEPAGE_GUIDE_CONTEXT_KEY = 'teambridge_h0391_home_guide';
export const HOMEPAGE_GUIDE_TTL = 30 * 60 * 1000;
const invalidatedStorage = new WeakSet();
// Attribution requires a fresh card click in this document; orphaned storage is ignored.
let navigationInvalidated = true;
const ORIGINS = ['https://teambridge.app', 'https://www.teambridge.app'];
export function homepageGuideStorage(browser) {
  try {
    return browser?.sessionStorage;
  } catch (_) {
    return undefined;
  }
}

// The homepage (landing page or signed-in game list) and /app, the same game list.
export function promotionVisible(pathname, now) {
  return (pathname === '/' || pathname === '/app') && Number.isFinite(now) && now < HOMEPAGE_GUIDE_EXPIRY;
}
export function promotionOperatorTest(storage) {
  try {
    return storage?.getItem('teambridge_operator_test') === 'true';
  } catch (_) {
    return false;
  }
}
function removeContext(storage) {
  try {
    if (!storage || typeof storage.removeItem !== 'function') return false;
    storage.removeItem(HOMEPAGE_GUIDE_CONTEXT_KEY);
    return true;
  } catch (_) {
    if (storage && (typeof storage === 'object' || typeof storage === 'function')) invalidatedStorage.add(storage);
    return false;
  }
}

// A route other than the destination abandons any unfinished card navigation.
export function discardHomepageGuideContext(storage, pathname) {
  if (pathname !== HOMEPAGE_GUIDE_PATH) {
    navigationInvalidated = true;
    removeContext(storage);
  }
}
function properties(location, operatorTest) {
  if (!location || !ORIGINS.includes(location.origin)) return null;
  return {
    schema_version: 1,
    source_pathname: '/',
    pathname: location.pathname,
    destination: HOMEPAGE_GUIDE_PATH,
    origin: location.origin,
    promotion_id: HOMEPAGE_GUIDE_PROMOTION,
    operator_test: operatorTest === true
  };
}
function capture(client, event, props) {
  try {
    if (!props || typeof client?.capture !== 'function') return false;
    client.capture(event, props);
    return true;
  } catch (_) {
    return false;
  }
}
export function captureHomepageGuideView(client, location, operatorTest, now) {
  return promotionVisible(location?.pathname, now) && capture(client, 'H0391 Homepage Guide Viewed', properties(location, operatorTest));
}
export function captureHomepageGuideClick(client, storage, location, operatorTest, now) {
  const cleared = removeContext(storage);
  if (!cleared || !promotionVisible(location?.pathname, now)) return false;
  const props = properties(location, operatorTest);
  if (!capture(client, 'H0391 Homepage Guide Click', props)) return false;
  try {
    storage.setItem(HOMEPAGE_GUIDE_CONTEXT_KEY, JSON.stringify({
      schema_version: 1,
      promotion_id: HOMEPAGE_GUIDE_PROMOTION,
      source_pathname: '/',
      destination: HOMEPAGE_GUIDE_PATH,
      origin: location.origin,
      clicked_at: now
    }));
    invalidatedStorage.delete(storage);
    navigationInvalidated = false;
    return true;
  } catch (_) {
    return false;
  }
}
export function captureHomepageGuideArrival(client, storage, location, operatorTest, now) {
  let context;
  try {
    context = JSON.parse(storage?.getItem(HOMEPAGE_GUIDE_CONTEXT_KEY) || 'null');
  } catch (_) {/* Invalid/blocked storage. */}
  const invalidated = navigationInvalidated || invalidatedStorage.has(storage);
  navigationInvalidated = true;
  const consumed = removeContext(storage);
  if (invalidated || !consumed || location?.pathname !== HOMEPAGE_GUIDE_PATH || !context || context.schema_version !== 1 || context.promotion_id !== HOMEPAGE_GUIDE_PROMOTION || context.source_pathname !== '/' || context.destination !== HOMEPAGE_GUIDE_PATH || context.origin !== location.origin || !Number.isFinite(context.clicked_at) || !Number.isFinite(now) || context.clicked_at >= HOMEPAGE_GUIDE_EXPIRY || now < context.clicked_at || now - context.clicked_at > HOMEPAGE_GUIDE_TTL) return false;
  const props = properties(location, operatorTest);
  return props ? capture(client, 'H0391 Homepage Guide Arrived', {
    ...props,
    context_valid: true
  }) : false;
}